import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo/logo.svg'
import _imports_1 from '@/assets/images/icons/schedule.png'
import _imports_2 from '@/assets/images/icons/abc.png'
import _imports_3 from '@/assets/images/icons/light.png'
import _imports_4 from '@/assets/images/emoji/happy.png'
import _imports_5 from '@/assets/images/emoji/5565d66a50b44df9ae37a955bdfb3757.png'
import _imports_6 from '@/assets/images/emoji/cf1f643bc1244f5e8e37767bc946d607.png'
import _imports_7 from '@/assets/images/emoji/5ede936757cd4fbdb6247bad22bf454d.png'
import _imports_8 from '@/assets/images/emoji/0b356bb507d64b9489e2fbced131f795.png'
import _imports_9 from '@/assets/images/icons/has_media.png'
import _imports_10 from '@/assets/images/icons/has_taught.png'
import _imports_11 from '@/assets/images/icons/goal-arrow.png'


const _withScopeId = n => (_pushScopeId("data-v-11a1426e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "__report-student px-10 md-down:px-4 pb-30"
}
const _hoisted_2 = { class: "pt-10 pb-4" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "__breadcrumbs text-sm text-neutral-500 font-semibold flex-nowrap flex items-center" }
const _hoisted_5 = { class: "__breadcrumbs__decorate" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Xem báo cáo", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-2 text-neutral-400",
  fill: "none",
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.5 7.99996L0.719131 7.37526L0.219375 7.99996L0.719131 8.62465L1.5 7.99996ZM7.5 8.99996C8.05228 8.99996 8.5 8.55224 8.5 7.99996C8.5 7.44767 8.05228 6.99996 7.5 6.99996V8.99996ZM3.3858 4.04193L0.719131 7.37526L2.28087 8.62465L4.94754 5.29132L3.3858 4.04193ZM0.719131 8.62465L3.3858 11.958L4.94754 10.7086L2.28087 7.37526L0.719131 8.62465ZM1.5 8.99996H7.5V6.99996H1.5V8.99996Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.78738 13.3439L8.31032 12.4915L7.78738 13.3439ZM6.97976 12.3905L6.05301 12.7662L6.97976 12.3905ZM14.499 12.5015L15.3875 12.9603L14.499 12.5015ZM12.7525 13.981L12.4461 13.0291L12.7525 13.981ZM14.499 3.49854L15.3875 3.0398L14.499 3.49854ZM13.8333 6.81921V9.18087H15.8333V6.81921H13.8333ZM7.83325 5.42133V5.29122H5.83325V5.42133H7.83325ZM9.58524 12.7782C8.62733 12.6186 8.43551 12.5683 8.31032 12.4915L7.26445 14.1962C7.80406 14.5273 8.47961 14.6216 9.25644 14.751L9.58524 12.7782ZM5.83325 10.7107C5.83325 11.4979 5.81518 12.1795 6.05301 12.7662L7.90651 12.0148C7.85132 11.8787 7.83325 11.6814 7.83325 10.7107H5.83325ZM8.31032 12.4915C8.12826 12.3798 7.98675 12.2128 7.90651 12.0148L6.05301 12.7662C6.29374 13.36 6.71828 13.8612 7.26445 14.1962L8.31032 12.4915ZM13.8333 9.18087C13.8333 10.0882 13.8325 10.7099 13.7946 11.1876C13.7573 11.6573 13.6894 11.8898 13.6104 12.0428L15.3875 12.9603C15.6428 12.4658 15.742 11.929 15.7883 11.3458C15.834 10.7705 15.8333 10.0557 15.8333 9.18087H13.8333ZM9.25644 14.751C10.1198 14.8949 10.8251 15.0132 11.4002 15.0628C11.9832 15.113 12.5291 15.1035 13.0589 14.9329L12.4461 13.0291C12.2822 13.0819 12.0416 13.1107 11.5719 13.0702C11.0943 13.029 10.4806 12.9275 9.58524 12.7782L9.25644 14.751ZM13.6104 12.0428C13.3679 12.5125 12.9493 12.8671 12.4461 13.0291L13.0589 14.9329C14.0653 14.609 14.9025 13.8997 15.3875 12.9603L13.6104 12.0428ZM9.58645 3.22163C10.4814 3.07248 11.0948 2.97099 11.5722 2.92986C12.0416 2.88942 12.2822 2.91819 12.4461 2.97096L13.0589 1.06717C12.5292 0.896646 11.9834 0.887021 11.4005 0.937243C10.8256 0.986778 10.1206 1.10503 9.25766 1.24885L9.58645 3.22163ZM15.8333 6.81921C15.8333 5.9444 15.834 5.22954 15.7883 4.65428C15.742 4.07104 15.6428 3.53429 15.3875 3.0398L13.6104 3.95728C13.6894 4.1103 13.7573 4.34283 13.7946 4.81252C13.8325 5.29019 13.8333 5.91191 13.8333 6.81921H15.8333ZM12.4461 2.97096C12.9493 3.13294 13.3679 3.48755 13.6104 3.95728L15.3875 3.0398C14.9025 2.10035 14.0653 1.39113 13.0589 1.06717L12.4461 2.97096ZM9.25766 1.24885C8.83685 1.31898 8.47124 1.37935 8.17099 1.45102C7.85987 1.52528 7.55473 1.62545 7.26252 1.80503L8.30967 3.50898C8.35038 3.48397 8.42887 3.44565 8.63532 3.39637C8.85265 3.3445 9.13857 3.29628 9.58645 3.22163L9.25766 1.24885ZM7.83325 5.29122C7.83325 4.83715 7.83381 4.5472 7.84925 4.3243C7.86391 4.11256 7.88881 4.02884 7.90679 3.98457L6.05387 3.23179C5.92477 3.54955 5.87613 3.86701 5.85403 4.1861C5.8327 4.49405 5.83325 4.86461 5.83325 5.29122H7.83325ZM7.26252 1.80503C6.71792 2.13971 6.29446 2.63958 6.05387 3.23179L7.90679 3.98457C7.98699 3.78717 8.12814 3.62054 8.30967 3.50898L7.26252 1.80503Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-2 text-neutral-400",
  fill: "none",
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.5 7.99996L0.719131 7.37526L0.219375 7.99996L0.719131 8.62465L1.5 7.99996ZM7.5 8.99996C8.05228 8.99996 8.5 8.55224 8.5 7.99996C8.5 7.44767 8.05228 6.99996 7.5 6.99996V8.99996ZM3.3858 4.04193L0.719131 7.37526L2.28087 8.62465L4.94754 5.29132L3.3858 4.04193ZM0.719131 8.62465L3.3858 11.958L4.94754 10.7086L2.28087 7.37526L0.719131 8.62465ZM1.5 8.99996H7.5V6.99996H1.5V8.99996Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.78738 13.3439L8.31032 12.4915L7.78738 13.3439ZM6.97976 12.3905L6.05301 12.7662L6.97976 12.3905ZM14.499 12.5015L15.3875 12.9603L14.499 12.5015ZM12.7525 13.981L12.4461 13.0291L12.7525 13.981ZM14.499 3.49854L15.3875 3.0398L14.499 3.49854ZM13.8333 6.81921V9.18087H15.8333V6.81921H13.8333ZM7.83325 5.42133V5.29122H5.83325V5.42133H7.83325ZM9.58524 12.7782C8.62733 12.6186 8.43551 12.5683 8.31032 12.4915L7.26445 14.1962C7.80406 14.5273 8.47961 14.6216 9.25644 14.751L9.58524 12.7782ZM5.83325 10.7107C5.83325 11.4979 5.81518 12.1795 6.05301 12.7662L7.90651 12.0148C7.85132 11.8787 7.83325 11.6814 7.83325 10.7107H5.83325ZM8.31032 12.4915C8.12826 12.3798 7.98675 12.2128 7.90651 12.0148L6.05301 12.7662C6.29374 13.36 6.71828 13.8612 7.26445 14.1962L8.31032 12.4915ZM13.8333 9.18087C13.8333 10.0882 13.8325 10.7099 13.7946 11.1876C13.7573 11.6573 13.6894 11.8898 13.6104 12.0428L15.3875 12.9603C15.6428 12.4658 15.742 11.929 15.7883 11.3458C15.834 10.7705 15.8333 10.0557 15.8333 9.18087H13.8333ZM9.25644 14.751C10.1198 14.8949 10.8251 15.0132 11.4002 15.0628C11.9832 15.113 12.5291 15.1035 13.0589 14.9329L12.4461 13.0291C12.2822 13.0819 12.0416 13.1107 11.5719 13.0702C11.0943 13.029 10.4806 12.9275 9.58524 12.7782L9.25644 14.751ZM13.6104 12.0428C13.3679 12.5125 12.9493 12.8671 12.4461 13.0291L13.0589 14.9329C14.0653 14.609 14.9025 13.8997 15.3875 12.9603L13.6104 12.0428ZM9.58645 3.22163C10.4814 3.07248 11.0948 2.97099 11.5722 2.92986C12.0416 2.88942 12.2822 2.91819 12.4461 2.97096L13.0589 1.06717C12.5292 0.896646 11.9834 0.887021 11.4005 0.937243C10.8256 0.986778 10.1206 1.10503 9.25766 1.24885L9.58645 3.22163ZM15.8333 6.81921C15.8333 5.9444 15.834 5.22954 15.7883 4.65428C15.742 4.07104 15.6428 3.53429 15.3875 3.0398L13.6104 3.95728C13.6894 4.1103 13.7573 4.34283 13.7946 4.81252C13.8325 5.29019 13.8333 5.91191 13.8333 6.81921H15.8333ZM12.4461 2.97096C12.9493 3.13294 13.3679 3.48755 13.6104 3.95728L15.3875 3.0398C14.9025 2.10035 14.0653 1.39113 13.0589 1.06717L12.4461 2.97096ZM9.25766 1.24885C8.83685 1.31898 8.47124 1.37935 8.17099 1.45102C7.85987 1.52528 7.55473 1.62545 7.26252 1.80503L8.30967 3.50898C8.35038 3.48397 8.42887 3.44565 8.63532 3.39637C8.85265 3.3445 9.13857 3.29628 9.58645 3.22163L9.25766 1.24885ZM7.83325 5.29122C7.83325 4.83715 7.83381 4.5472 7.84925 4.3243C7.86391 4.11256 7.88881 4.02884 7.90679 3.98457L6.05387 3.23179C5.92477 3.54955 5.87613 3.86701 5.85403 4.1861C5.8327 4.49405 5.83325 4.86461 5.83325 5.29122H7.83325ZM7.26252 1.80503C6.71792 2.13971 6.29446 2.63958 6.05387 3.23179L7.90679 3.98457C7.98699 3.78717 8.12814 3.62054 8.30967 3.50898L7.26252 1.80503Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_9 = { class: "__report-student__header pt-5" }
const _hoisted_10 = { class: "flex justify-between md:items-center w-full md-down:flex-col md-down:justify-start rounded-xl" }
const _hoisted_11 = { class: "flex w-full items-center md-down:mb-8" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "font-medium leading-none text-white text-4xl" }
const _hoisted_14 = { class: "ml-4" }
const _hoisted_15 = { class: "font-bold text-neutral-700 text-4xl md-down:text-2xl" }
const _hoisted_16 = {
  key: 0,
  class: "text-green-500 font-semibold text-xs uppercase letter-spacing-8"
}
const _hoisted_17 = {
  key: 1,
  class: "text-green-500 font-semibold text-xs uppercase"
}
const _hoisted_18 = {
  key: 0,
  class: "flex md-down:w-full justify-start md-down:justify-end md-down:flex-row-reverse"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "relative" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "aria-hidden": "true",
  class: "absolute inset-0 flex items-center"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-full border-t border-neutral-300" })
], -1))
const _hoisted_23 = { class: "relative flex justify-center" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "16",
  viewBox: "0 0 17 16",
  width: "17",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M12.9705 6.65078L14.2105 5.41075C14.3463 5.27489 14.4143 5.20696 14.4669 5.14499C15.1011 4.39832 15.1011 3.30214 14.4669 2.55546C14.4143 2.4935 14.3463 2.42557 14.2105 2.28971C14.0746 2.15385 14.0067 2.08592 13.9447 2.03329C13.1981 1.39906 12.1019 1.39906 11.3552 2.03329C11.2933 2.08591 11.2253 2.15382 11.0895 2.28961L11.0895 2.28968L11.0894 2.28971L9.83123 3.54792C10.5749 4.84212 11.6586 5.91739 12.9705 6.65078ZM8.37657 5.00258L3.36297 10.0162C2.93791 10.4412 2.72538 10.6538 2.58565 10.9149C2.44591 11.176 2.38697 11.4707 2.26908 12.0601L1.87342 14.0384C1.8069 14.371 1.77364 14.5373 1.86825 14.6319C1.96286 14.7266 2.12916 14.6933 2.46177 14.6268L4.44005 14.2311L4.44007 14.2311L4.44009 14.2311C5.02951 14.1132 5.32423 14.0543 5.58532 13.9145C5.84641 13.7748 6.05894 13.5623 6.48398 13.1373L6.484 13.1372L6.48401 13.1372L11.512 8.10922C10.2513 7.311 9.18226 6.24913 8.37657 5.00258Z",
    fill: "#94A3B8",
    "fill-rule": "evenodd"
  })
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-2 text-sm text-neutral-600" }, " Chỉnh sửa ", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.9987 1.33203L7.33844 0.58099L7.9987 0.000545536L8.65895 0.58099L7.9987 1.33203ZM2.67178 4.68356L7.33844 0.58099L8.65895 2.08307L3.99229 6.18564L2.67178 4.68356ZM8.65895 0.58099L13.3256 4.68355L12.0051 6.18564L7.33844 2.08307L8.65895 0.58099ZM8.9987 1.33203L8.9987 6.66537L6.9987 6.66537L6.9987 1.33203L8.9987 1.33203Z",
    fill: "#94A3B8"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M6.9987 8V10.9167C6.9987 11.469 7.44641 11.9167 7.9987 11.9167C8.55098 11.9167 8.9987 11.469 8.9987 10.9167V8H12.6654C13.7699 8 14.6654 8.89543 14.6654 10V12.6667C14.6654 13.7712 13.7699 14.6667 12.6654 14.6667H3.33203C2.22746 14.6667 1.33203 13.7712 1.33203 12.6667V10C1.33203 8.89543 2.22746 8 3.33203 8H6.9987Z",
    fill: "#94A3B8",
    "fill-rule": "evenodd"
  })
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-2 text-sm text-neutral-600" }, " Chia sẻ ", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div class=\"relative\" data-v-11a1426e><div aria-hidden=\"true\" class=\"absolute inset-0 flex items-center\" data-v-11a1426e><div class=\"w-full border-t border-neutral-300\" data-v-11a1426e></div></div><div class=\"relative flex justify-center\" data-v-11a1426e><div class=\"px-2.5 py-1 bg-body text-neutral-600 font-semibold pb-2.5\" data-v-11a1426e> Làm báo cáo </div></div></div>", 1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 2,
  class: "mt-10"
}
const _hoisted_34 = {
  key: 0,
  class: "bg-yellow-50 border-l-4 border-yellow-600 p-4 rounded-md"
}
const _hoisted_35 = { class: "relative" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "luca-logo",
      height: "24",
      src: _imports_0,
      width: "35"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "pt-1 text-neutral-600 text-sm" }, [
    /*#__PURE__*/_createTextVNode(" Bạn hãy hoàn thành "),
    /*#__PURE__*/_createElementVNode("span", { class: "font-semibold underline" }, "Nhận xét chung của cả tuần"),
    /*#__PURE__*/_createTextVNode(" để nộp báo cáo ")
  ])
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "12",
  viewBox: "0 0 12 12",
  width: "12",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z",
    fill: "#E5A42B",
    "fill-rule": "evenodd"
  })
], -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 3,
  class: "pt-10 pb-4"
}
const _hoisted_40 = { class: "bg-white shadow-sm rounded-2xl overflow-hidden p-6" }
const _hoisted_41 = { class: "flex items-center justify-between mb-4" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-700" }, " Nhận xét chung của cả tuần ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.6308 5.68775L15.8838 3.43471C16.7496 2.56893 17.1825 2.13604 17.6895 1.99526C18.0396 1.89806 18.4095 1.89806 18.7596 1.99526C19.2667 2.13604 19.6996 2.56893 20.5653 3.43471C21.4311 4.3005 21.864 4.73339 22.0048 5.24044C22.102 5.59052 22.102 5.96046 22.0048 6.31054C21.864 6.8176 21.4311 7.25049 20.5653 8.11627L18.3384 10.3432C16.3859 9.2234 14.7651 7.61489 13.6308 5.68775ZM12.1764 7.14212L3.8659 15.4526C3.44084 15.8777 3.22831 16.0902 3.08857 16.3513C2.94884 16.6124 2.88989 16.9071 2.772 17.4966L1.98622 21.4255C1.91969 21.7581 1.88643 21.9244 1.98104 22.019C2.07564 22.1136 2.24194 22.0804 2.57452 22.0139L2.57455 22.0139L2.57456 22.0138L6.50349 21.2281L6.50351 21.2281C7.09295 21.1102 7.38767 21.0512 7.64876 20.9115C7.90986 20.7718 8.12239 20.5592 8.54743 20.1342L8.54745 20.1342L16.8803 11.8013C14.9786 10.6172 13.3722 9.02191 12.1764 7.14212Z",
  fill: "#E5A42B"
}, null, -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = {
  key: 1,
  class: "text-neutral-400"
}
const _hoisted_47 = { key: 4 }
const _hoisted_48 = /*#__PURE__*/_createStaticVNode("<div class=\"relative\" data-v-11a1426e><div aria-hidden=\"true\" class=\"absolute inset-0 flex items-center\" data-v-11a1426e><div class=\"w-full border-t border-neutral-300\" data-v-11a1426e></div></div><div class=\"relative flex justify-center\" data-v-11a1426e><div class=\"px-2.5 py-1 bg-body text-neutral-600 font-semibold pb-2.5\" data-v-11a1426e> Nội dung báo cáo </div></div></div>", 1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = {
  key: 5,
  class: "mt-10"
}
const _hoisted_51 = { class: "bg-white shadow-sm rounded-2xl overflow-hidden" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-orange-50 p-4 px-6 font-semibold text-lg text-gray-700" }, " Báo cáo tuần ", -1))
const _hoisted_53 = { class: "flex items-center justify-between flex-nowrap md-down:flex-col md-down:items-start p-4 px-6" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { class: "font-semibold text-blue-700" }
const _hoisted_57 = {
  key: 6,
  class: "mt-10"
}
const _hoisted_58 = { class: "bg-white shadow-sm rounded-2xl" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-600 p-6" }, " Nhận xét chung của cả tuần ", -1))
const _hoisted_60 = ["innerHTML"]
const _hoisted_61 = { class: "mt-10" }
const _hoisted_62 = { class: "p-6 bg-white shadow-sm rounded-2xl" }
const _hoisted_63 = { class: "font-semibold text-neutral-600 mb-6" }
const _hoisted_64 = { class: "flex flex-nowrap w-full md-down:flex-col" }
const _hoisted_65 = { class: "p-6 border rounded-l-lg border-neutral-200 w-full md-down:rounded-t md-down:rounded-b-none" }
const _hoisted_66 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "mr-2 mb-1",
  height: "32",
  src: _imports_1,
  style: {"height":"32px"},
  width: "32"
}, null, -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số buổi học ")
], -1))
const _hoisted_69 = { class: "p-6 border-t border-b border-neutral-200 w-full md-down:border-l md-down:border-r md-down:border-t-0 md-down:border-b-0" }
const _hoisted_70 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "mr-2",
  height: "32",
  src: _imports_2,
  style: {"height":"32px"},
  width: "32"
}, null, -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số lĩnh vực đã học ")
], -1))
const _hoisted_73 = { class: "p-6 border rounded-r-lg border-neutral-200 w-full md-down:rounded-b md-down:rounded-t-none" }
const _hoisted_74 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "mr-2",
  height: "32",
  src: _imports_3,
  style: {"height":"32px"},
  width: "32"
}, null, -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số mục tiêu đã học")
], -1))
const _hoisted_77 = { class: "mt-10" }
const _hoisted_78 = { class: "grid grid-cols-2 gap-8 xl-down:grid-cols-1" }
const _hoisted_79 = { class: "bg-white shadow-sm rounded-2xl overflow-hidden" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500 p-6" }, " Cảm xúc của trẻ trong tuần ", -1))
const _hoisted_81 = { class: "border-t border-orange-50 flex justify-center items-center p-6 md-down:flex-col" }
const _hoisted_82 = { class: "relative w-1/2 md-down:w-full" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-center absolute top-1/2 left-1/2 transform",
  style: {"transform":"translate(-50%, -50%)"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500" }, "Cảm xúc")
], -1))
const _hoisted_84 = { class: "w-1/3 md-down:w-full md-down:mt-4" }
const _hoisted_85 = {
  key: 0,
  class: "flex flex-nowrap items-center justify-between w-full"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "",
    height: "24",
    src: _imports_4,
    width: "24"
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "h-2.5 w-2.5 rounded-full ml-2",
    style: {"background":"#9edf93"}
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "ml-2 text-base text-neutral-500" }, " Vui vẻ ")
], -1))
const _hoisted_87 = { class: "text-base text-neutral-600 font-bold" }
const _hoisted_88 = {
  key: 1,
  class: "flex flex-nowrap items-center justify-between w-full mt-2.5"
}
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "",
    height: "24",
    src: _imports_5,
    width: "24"
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "h-2.5 w-2.5 rounded-full ml-2",
    style: {"background":"#d0db54"}
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "ml-2 text-base text-neutral-500" }, " Bình thường ")
], -1))
const _hoisted_90 = { class: "text-base text-neutral-600 font-bold" }
const _hoisted_91 = {
  key: 2,
  class: "flex flex-nowrap items-center justify-between w-full mt-2.5"
}
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "",
    height: "24",
    src: _imports_6,
    width: "24"
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "h-2.5 w-2.5 rounded-full ml-2",
    style: {"background":"#ffe68c"}
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "ml-2 text-base text-neutral-500" }, " Khó chịu ")
], -1))
const _hoisted_93 = { class: "text-base text-neutral-600 font-bold" }
const _hoisted_94 = {
  key: 3,
  class: "flex flex-nowrap items-center justify-between w-full mt-2.5"
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "",
    height: "24",
    src: _imports_7,
    width: "24"
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "h-2.5 w-2.5 rounded-full ml-2",
    style: {"background":"#ff9d6d"}
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "ml-2 text-base text-neutral-500" }, " Tức giận ")
], -1))
const _hoisted_96 = { class: "text-base text-neutral-600 font-bold" }
const _hoisted_97 = {
  key: 4,
  class: "flex flex-nowrap items-center justify-between w-full mt-2.5"
}
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "",
    height: "24",
    src: _imports_8,
    width: "24"
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "h-2.5 w-2.5 rounded-full ml-2",
    style: {"background":"#ff6967"}
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "ml-2 text-base text-neutral-500" }, " Bùng nổ ")
], -1))
const _hoisted_99 = { class: "text-base text-neutral-600 font-bold" }
const _hoisted_100 = { class: "bg-white shadow-sm rounded-2xl overflow-hidden" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500 p-6" }, " Kết quả mục tiêu đã học ", -1))
const _hoisted_102 = { class: "flex flex-nowrap p-6 border-t border-orange-50 items-center justify-center md-down:flex-col" }
const _hoisted_103 = { class: "relative w-fit md-down:w-full" }
const _hoisted_104 = {
  class: "text-center absolute top-1/2 left-1/2 transform",
  style: {"transform":"translate(-50%, -50%)"}
}
const _hoisted_105 = { class: "text-4xl font-bold text-neutral-600" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500" }, "Mục tiêu", -1))
const _hoisted_107 = { class: "flex flex-col justify-center md-down:mt-4" }
const _hoisted_108 = {
  key: 0,
  class: "flex flex-nowrap items-center mb-4"
}
const _hoisted_109 = { class: "text-sm font-semibold text-neutral-500 w-14 blue" }
const _hoisted_110 = {
  class: "flex items-center justify-center py-0.5 rounded-full text-sm font-medium text-white whitespace-nowrap w-32 shadow-input",
  style: {"background":"#2aa797"}
}
const _hoisted_111 = {
  key: 1,
  class: "flex flex-nowrap items-center mb-4"
}
const _hoisted_112 = { class: "text-sm font-semibold text-neutral-500 w-14" }
const _hoisted_113 = {
  class: "flex items-center justify-center py-0.5 rounded-full text-sm font-medium text-white w-32 whitespace-nowrap shadow-input",
  style: {"background":"#65a30d"}
}
const _hoisted_114 = {
  key: 2,
  class: "flex flex-nowrap items-center mb-4"
}
const _hoisted_115 = { class: "text-sm font-semibold text-neutral-500 w-14" }
const _hoisted_116 = {
  class: "flex items-center justify-center py-0.5 rounded-full text-sm font-medium text-white w-32 whitespace-nowrap shadow-input",
  style: {"background":"#f59e0b"}
}
const _hoisted_117 = {
  key: 3,
  class: "flex flex-nowrap items-center mb-4"
}
const _hoisted_118 = { class: "text-sm font-semibold text-neutral-500 w-14 blue" }
const _hoisted_119 = {
  class: "flex items-center justify-center px-3 py-0.5 rounded-full text-sm font-medium text-white w-32 whitespace-nowrap shadow-input",
  style: {"background":"#f87171"}
}
const _hoisted_120 = {
  key: 4,
  class: "flex flex-nowrap items-center mb-4"
}
const _hoisted_121 = { class: "text-sm font-semibold text-neutral-500 w-14 blue" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "flex items-center justify-center px-3 py-0.5 rounded-full text-sm font-medium text-white w-32 whitespace-nowrap shadow-input",
  style: {"background":"#9ca3af"}
}, " X ", -1))
const _hoisted_123 = { class: "bg-white shadow-sm rounded-2xl overflow-hidden" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500 p-6" }, " So sánh với tuần trước ", -1))
const _hoisted_125 = { class: "border-t border-orange-50 grid grid-cols-3 items-start md-down:grid-cols-1" }
const _hoisted_126 = { class: "flex flex-col justify-center items-center py-6 w-full" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "clip-rule": "evenodd",
  d: "M4.36354 0.498901V9.45415L1.4547 6.54531L0.5 7.50001L5 12L9.5 7.50001L8.5453 6.54531L5.63646 9.45415V0.498901H4.36354Z",
  fill: "currentColor",
  "fill-rule": "evenodd"
}, null, -1))
const _hoisted_128 = [
  _hoisted_127
]
const _hoisted_129 = { class: "ml-2 font-bold text-sm text-neutral-700" }
const _hoisted_130 = { class: "flex flex-col justify-center items-center py-6" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "clip-rule": "evenodd",
  d: "M4.36354 0.498901V9.45415L1.4547 6.54531L0.5 7.50001L5 12L9.5 7.50001L8.5453 6.54531L5.63646 9.45415V0.498901H4.36354Z",
  fill: "currentColor",
  "fill-rule": "evenodd"
}, null, -1))
const _hoisted_132 = [
  _hoisted_131
]
const _hoisted_133 = { class: "ml-2 font-bold text-sm text-neutral-700" }
const _hoisted_134 = { class: "flex flex-col justify-center items-center py-6" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "clip-rule": "evenodd",
  d: "M4.36354 0.498901V9.45415L1.4547 6.54531L0.5 7.50001L5 12L9.5 7.50001L8.5453 6.54531L5.63646 9.45415V0.498901H4.36354Z",
  fill: "currentColor",
  "fill-rule": "evenodd"
}, null, -1))
const _hoisted_136 = [
  _hoisted_135
]
const _hoisted_137 = { class: "ml-2 font-bold text-sm text-neutral-700" }
const _hoisted_138 = { class: "bg-white shadow-sm rounded-2xl overflow-hidden" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500 p-6" }, " Chuyên cần ", -1))
const _hoisted_140 = { class: "border-t border-orange-50 p-6 flex items-center justify-center flex-col" }
const _hoisted_141 = {
  class: "text-neutral-600 font-semibold mb-5",
  style: {"font-size":"72px"}
}
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 mb-2 text-center" }, " Số buổi học tuần này ", -1))
const _hoisted_143 = {
  key: 0,
  class: "text-neutral-400 italic font-light"
}
const _hoisted_144 = {
  key: 1,
  class: "text-neutral-500 mb-5"
}
const _hoisted_145 = {
  key: 2,
  class: "flex items-center"
}
const _hoisted_146 = {
  key: 0,
  class: "text-neutral-600 text-4xl font-semibold mr-3"
}
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "clip-rule": "evenodd",
  d: "M4.36354 0.498901V9.45415L1.4547 6.54531L0.5 7.50001L5 12L9.5 7.50001L8.5453 6.54531L5.63646 9.45415V0.498901H4.36354Z",
  fill: "currentColor",
  "fill-rule": "evenodd"
}, null, -1))
const _hoisted_148 = [
  _hoisted_147
]
const _hoisted_149 = { class: "ml-2 font-bold text-sm text-neutral-700" }
const _hoisted_150 = {
  key: 7,
  class: "mt-10"
}
const _hoisted_151 = { class: "bg-white shadow-sm rounded-2xl overflow-hidden mb-10 pb-5" }
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500 p-6" }, " Biểu đồ mối tương quan giữa kết quả các lĩnh vực trong tuần ", -1))
const _hoisted_153 = { class: "p-6 border-t border-orange-50 md-down:px-0 overflow-x-auto w-full" }
const _hoisted_154 = { class: "py-4 flex flex-wrap gap-6 justify-center items-center" }
const _hoisted_155 = { class: "font-bold text-lf text-neutral-700" }
const _hoisted_156 = { class: "mt-10" }
const _hoisted_157 = { class: "bg-white shadow-sm rounded-2xl overflow-hidden mb-10 pb-5" }
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500 p-6" }, " Mối tương quan giữa kết quả, cảm xúc và sự tham gia của trẻ trong tuần ", -1))
const _hoisted_159 = { class: "p-6 border-t border-orange-50 md-down:px-0" }
const _hoisted_160 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-10\" data-v-11a1426e><div class=\"relative\" data-v-11a1426e><div aria-hidden=\"true\" class=\"absolute inset-0 flex items-center\" data-v-11a1426e><div class=\"w-full border-t border-neutral-300\" data-v-11a1426e></div></div><div class=\"relative flex justify-center cursor-pointer\" data-v-11a1426e><div class=\"px-3 bg-body p-2 text-lg font-semibold text-neutral-600 flex items-center\" data-v-11a1426e><div class=\"ml-2 text-sm text-neutral-600\" data-v-11a1426e> Kết quả mục tiêu đã học </div></div></div></div></div>", 1)
const _hoisted_161 = { class: "font-semibold text-lg text-neutral-600 mb-2" }
const _hoisted_162 = { class: "shadow-sm sm:rounded-2xl overflow-hidden md-down:hidden" }
const _hoisted_163 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_164 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_165 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap w-16",
      scope: "col"
    }, " STT "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-8/12 whitespace-nowrap",
      scope: "col"
    }, " Mục Tiêu "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-8/12 whitespace-nowrap",
      scope: "col"
    }, " ALBUM "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap",
      scope: "col",
      style: {"width":"170px"}
    }, " Kết quả ")
  ])
], -1))
const _hoisted_167 = ["onClick"]
const _hoisted_168 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_169 = { class: "ml-4" }
const _hoisted_170 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_171 = { class: "whitespace-normal" }
const _hoisted_172 = { class: "flex items-center" }
const _hoisted_173 = {
  key: 0,
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-neutral-200 text-neutral-700 h-fit w-fit whitespace-nowrap font-semibold shadow-input",
  style: {"font-size":"10px"}
}
const _hoisted_174 = {
  key: 1,
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-neutral-200 text-neutral-700 h-fit w-fit whitespace-nowrap font-semibold shadow-input",
  style: {"font-size":"10px"}
}
const _hoisted_175 = {
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-pink-100 whitespace-nowrap text-neutral-700 h-fit w-fit font-semibold shadow-input",
  style: {"font-size":"10px"}
}
const _hoisted_176 = { class: "flex items-center gap-2 mt-2" }
const _hoisted_177 = { key: 0 }
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: _imports_9
}, null, -1))
const _hoisted_179 = [
  _hoisted_178
]
const _hoisted_180 = {
  key: 1,
  class: "text-neutral-400 text-xs font-semibold"
}
const _hoisted_181 = { key: 2 }
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: _imports_10
}, null, -1))
const _hoisted_183 = [
  _hoisted_182
]
const _hoisted_184 = {
  key: 0,
  class: "goal-block flex gap-3 mt-2"
}
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-3 h-3 mt-1",
  src: _imports_11,
  alt: ""
}, null, -1))
const _hoisted_186 = { class: "whitespace-nowrap text-neutral-700" }
const _hoisted_187 = { class: "text-neutral-400 text-xs font-semibold" }
const _hoisted_188 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_189 = {
  key: 0,
  fill: "none",
  height: "20",
  viewBox: "0 0 20 20",
  width: "20",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "clip-rule": "evenodd",
  d: "M15.002 5H2.50195C1.8116 5 1.25195 5.55964 1.25195 6.25V16.25L4.56001 13.3081C4.77068 13.0974 5.10075 13.0647 5.34864 13.23L8.67232 15.4458L13.31 10.8081C13.5002 10.6179 13.7908 10.5707 14.0315 10.691L16.252 13.125V6.25C16.252 5.55964 15.6923 5 15.002 5ZM2.50195 3.75C1.12124 3.75 0.00195312 4.86929 0.00195312 6.25V16.25C0.00195312 17.6307 1.12124 18.75 2.50195 18.75H15.002C16.3827 18.75 17.502 17.6307 17.502 16.25V6.25C17.502 4.86929 16.3827 3.75 15.002 3.75H2.50195ZM7.50195 9.375C7.50195 10.4105 6.66249 11.25 5.62695 11.25C4.59142 11.25 3.75195 10.4105 3.75195 9.375C3.75195 8.33947 4.59142 7.5 5.62695 7.5C6.66249 7.5 7.50195 8.33947 7.50195 9.375Z",
  fill: "#E5A42B",
  "fill-rule": "evenodd"
}, null, -1))
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "clip-rule": "evenodd",
  d: "M4.5 2.25H18C18.5523 2.25 19 2.69772 19 3.25V14.25C19 14.8023 18.5523 15.25 18 15.25H17.5V16.25H18C19.1046 16.25 20 15.3546 20 14.25V3.25C20 2.14543 19.1046 1.25 18 1.25H4.5C3.39543 1.25 2.5 2.14543 2.5 3.25V3.75H3.5V3.25C3.5 2.69772 3.94772 2.25 4.5 2.25Z",
  fill: "#E5A42B",
  "fill-rule": "evenodd"
}, null, -1))
const _hoisted_192 = [
  _hoisted_190,
  _hoisted_191
]
const _hoisted_193 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_194 = ["onClick"]
const _hoisted_195 = { class: "font-semibold text-neutral-600 p-4" }
const _hoisted_196 = {
  key: 0,
  class: "flex gap-2"
}
const _hoisted_197 = {
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-pink-100 whitespace-nowrap text-neutral-700 h-fit w-fit font-semibold shadow-input",
  style: {"font-size":"10px"}
}
const _hoisted_198 = { class: "p-4 border-t border-orange-100" }
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uppercase font-semibold text-neutral-400" }, " Kết quả ", -1))
const _hoisted_200 = {
  key: 1,
  class: "fixed top-1/2 left-1/2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NoteSlide = _resolveComponent("NoteSlide")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_ExitModal = _resolveComponent("ExitModal")!
  const _component_CopyModal = _resolveComponent("CopyModal")!
  const _component_DaModalFrame = _resolveComponent("DaModalFrame")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.sideOverShow ? 'side-over--active' : '')
    }, [
      (_ctx.sideOverShow)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sideOverShow = false))
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_NoteSlide, {
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sideOverShow = false)),
        onSubmit: _ctx.submitNoteContent,
        noteContent: _ctx.noteContent,
        weekly: true
      }, null, 8, ["onSubmit", "noteContent"])
    ], 2),
    _createVNode(_component_DaModalFrame, {
      open: _ctx.modalIsOpen,
      "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalIsOpen) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.modalType === _ctx.modalTypes.CONFIRM)
          ? (_openBlock(), _createBlock(_component_ConfirmModal, {
              key: 0,
              success: _ctx.successData,
              "onUpdate:success": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.successData) = $event)),
              data: _ctx.reportData,
              onClose: _ctx.cancelConfirm,
              onSubmit: _ctx.confirmSubmit
            }, null, 8, ["success", "data", "onClose", "onSubmit"]))
          : _createCommentVNode("", true),
        (_ctx.modalType === _ctx.modalTypes.EXIT)
          ? (_openBlock(), _createBlock(_component_ExitModal, {
              key: 1,
              onClose: _ctx.cancelConfirm,
              onSubmit: _ctx.cancel
            }, null, 8, ["onClose", "onSubmit"]))
          : _createCommentVNode("", true),
        (_ctx.modalType === _ctx.modalTypes.COPY)
          ? (_openBlock(), _createBlock(_component_CopyModal, {
              key: 2,
              path: _ctx.path,
              "onUpdate:path": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.path) = $event)),
              onClose: _ctx.closeShare
            }, null, 8, ["path", "onClose"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["open"]),
    _createElementVNode("div", null, [
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_router_link, {
                    to: {
								path: _ctx.is_old_data
									? '/transferred-data'
									: '/report/week',
							}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.is_old_data
									? 'Xem hồ sơ cũ'
									: 'Danh sách học sinh'), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_DaIcon, {
                      class: "transform -rotate-90 h-3 w-3 mx-2",
                      name: "das--chevron-down"
                    })
                  ]),
                  _hoisted_6
                ]),
                (_ctx.is_old_data)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "button-p text-center w-fit btn--text text-neutral-500 hover:text-neutral-600",
                      type: "button",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.exitOldData && _ctx.exitOldData(...args)))
                    }, [
                      _hoisted_7,
                      _createTextVNode(" Thoát ")
                    ]))
                  : (_ctx.editReport)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "button-p text-center w-fit btn--text text-neutral-500 hover:text-neutral-600",
                        type: "button",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.exit && _ctx.exit(...args)))
                      }, [
                        _hoisted_8,
                        _createTextVNode(" Thoát ")
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_router_link, {
                    to: `/record/student/${_ctx.weeklyReport?.student?.id}`
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        (
										_ctx.weeklyReport?.student?.profile_photo
											?.w200
									)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: 
										_ctx.weeklyReport?.student?.profile_photo
											?.w200
									,
                              alt: "",
                              class: "shadow-sm inline-block h-14 w-14 rounded-full"
                            }, null, 8, _hoisted_12))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              style: _normalizeStyle({
										background:
											_ctx.weeklyReport?.student?.profile_photo
												?.default?.color,
									}),
                              class: "inline-flex items-center justify-center h-14 w-14 rounded-full"
                            }, [
                              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.weeklyReport?.student?.profile_photo
												?.default?.initial), 1)
                            ], 4)),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.weeklyReport?.student?.name), 1),
                          (_ctx.is_old_data && _ctx.dateData)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.dateData), 1))
                            : (_ctx.weeklyReport?.student?.age)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.weeklyReport?.student?.age) + " " + _toDisplayString(_ctx.weeklyReport?.student?.learning_time
												? `| ${_ctx.weeklyReport?.student?.learning_time}`
												: ''), 1))
                              : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  (_ctx.editReport)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("div", null, [
                          _createElementVNode("button", {
                            disabled: !_ctx.noteContent,
                            class: "button-p text-center w-44",
                            type: "button",
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                          }, " Hoàn thành báo cáo ", 8, _hoisted_19)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (!_ctx.editReport && !_ctx.is_old_data)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", {
                        class: "px-3 bg-white p-2 text-lg font-semibold text-neutral-600 flex items-center shadow-sm rounded cursor-pointer border-neutral-200 border",
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.edit && _ctx.edit(...args)))
                      }, _hoisted_26),
                      false
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "px-3 bg-white p-2 text-lg font-semibold text-neutral-600 flex items-center shadow-sm rounded cursor-pointer border-neutral-200 border ml-1",
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.openShare && _ctx.openShare(...args)))
                          }, _hoisted_29))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.editReport)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
              : _createCommentVNode("", true),
            (!_ctx.weeklyReport.note && _ctx.editReport)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  (_ctx.alertShow)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _createElementVNode("div", {
                            class: "top-1 right-2 absolute cursor-pointer",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.alertShow = false))
                          }, _hoisted_38)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.editReport)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      (_openBlock(), _createElementBlock("svg", {
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sideOverShow = true)),
                        class: "cursor-pointer",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, _hoisted_44))
                    ]),
                    _createElementVNode("div", null, [
                      (_ctx.noteContent)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "text-neutral-700",
                            innerHTML: _ctx.noteContent.replace(/\n/g, '<br />')
                          }, null, 8, _hoisted_45))
                        : (_openBlock(), _createElementBlock("div", _hoisted_46, " Nhận xét chung/ lưu ý cho phụ huynh "))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.editReport)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, _hoisted_49))
              : _createCommentVNode("", true),
            (!_ctx.editReport)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _createElementVNode("div", _hoisted_53, [
                      (_ctx.week_start)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(`Tuần ${_ctx.$filters.toWeek(
									_ctx.week_start,
									true
								)} (${_ctx.$filters.formatDate2(
									_ctx.week_start
								)} - ${_ctx.$filters.endWeek(_ctx.week_start)})`), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_router_link, {
                        to: `/record/student/${_ctx.weeklyReport?.submitted_by_staff?.id}`
                      }, {
                        default: _withCtx(() => [
                          (_ctx.weeklyReport?.submitted_by_staff)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                _createTextVNode(" Trị liệu viên "),
                                _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.weeklyReport?.submitted_by_staff?.name), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.weeklyReport?.note && !_ctx.editReport)
              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _hoisted_59,
                    _createElementVNode("div", {
                      class: "p-6 border-t border-orange-100 whitespace-pre-line",
                      innerHTML: _ctx.weeklyReport?.note
                    }, null, 8, _hoisted_60)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, " Thống kê chung " + _toDisplayString(`Tuần ${_ctx.$filters.toWeek(
								_ctx.week_start,
								true
							)} (${_ctx.$filters.formatDate2(
								_ctx.week_start
							)} - ${_ctx.$filters.endWeek(_ctx.week_start)})`), 1),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _hoisted_67,
                      _createTextVNode(" " + _toDisplayString(_ctx.weeklyReport?.lesson_count), 1)
                    ]),
                    _hoisted_68
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _hoisted_71,
                      _createTextVNode(" " + _toDisplayString(_ctx.weeklyReport?.skill_count), 1)
                    ]),
                    _hoisted_72
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, [
                      _hoisted_75,
                      _createTextVNode(" " + _toDisplayString(_ctx.weeklyReport?.goal_count), 1)
                    ]),
                    _hoisted_76
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, [
                  _hoisted_80,
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                      _createVNode(_component_apexchart, {
                        options: _ctx.chartOptions3,
                        series: _ctx.series3,
                        height: "220",
                        type: "donut"
                      }, null, 8, ["options", "series"]),
                      _hoisted_83
                    ]),
                    _createElementVNode("div", _hoisted_84, [
                      (_ctx.series3[0] > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                            _hoisted_86,
                            _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.series3[0]) + " % ", 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.series3[1] > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                            _hoisted_89,
                            _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.series3[1]) + " % ", 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.series3[2] > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                            _hoisted_92,
                            _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.series3[2]) + " % ", 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.series3[3] > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                            _hoisted_95,
                            _createElementVNode("div", _hoisted_96, _toDisplayString(_ctx.series3[3]) + " % ", 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.series3[4] > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                            _hoisted_98,
                            _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.series3[4]) + " % ", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_100, [
                  _hoisted_101,
                  _createElementVNode("div", _hoisted_102, [
                    _createElementVNode("div", _hoisted_103, [
                      _createVNode(_component_apexchart, {
                        options: _ctx.chartOptions,
                        series: _ctx.series,
                        height: "220",
                        type: "donut"
                      }, null, 8, ["options", "series"]),
                      _createElementVNode("div", _hoisted_104, [
                        _createElementVNode("div", _hoisted_105, _toDisplayString(_ctx.weeklyReport?.goal_count), 1),
                        _hoisted_106
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_107, [
                      (_ctx.assessment_result[0]?.count > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                            _createElementVNode("div", _hoisted_109, _toDisplayString(_ctx.assessment_result[0]?.count) + " M.T ", 1),
                            _createElementVNode("span", _hoisted_110, _toDisplayString(_ctx.assessment_result[0]?.result), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.assessment_result[1]?.count > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                            _createElementVNode("div", _hoisted_112, _toDisplayString(_ctx.assessment_result[1]?.count) + " M.T ", 1),
                            _createElementVNode("span", _hoisted_113, _toDisplayString(_ctx.assessment_result[1]?.result), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.assessment_result[2]?.count > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                            _createElementVNode("div", _hoisted_115, _toDisplayString(_ctx.assessment_result[2]?.count) + " M.T ", 1),
                            _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.assessment_result[2]?.result), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.assessment_result[3]?.count > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                            _createElementVNode("div", _hoisted_118, _toDisplayString(_ctx.assessment_result[3]?.count) + " M.T ", 1),
                            _createElementVNode("span", _hoisted_119, _toDisplayString(_ctx.assessment_result[3]?.result), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (
										_ctx.assessment_result[4]?.count > 0 ||
										_ctx.assessment_result[5]?.count > 0 ||
										_ctx.assessment_result[6]?.count > 0
									)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                            _createElementVNode("div", _hoisted_121, _toDisplayString(_ctx.assessment_result[4]?.count +
											_ctx.assessment_result[5]?.count +
											_ctx.assessment_result[6]?.count) + " M.T ", 1),
                            _hoisted_122
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_123, [
                  _hoisted_124,
                  _createElementVNode("div", _hoisted_125, [
                    _createElementVNode("div", _hoisted_126, [
                      _createVNode(_component_apexchart, {
                        options: _ctx.chartOptions2_1,
                        series: [
										+_ctx.weeklyReport?.average_result_in_percent,
									],
                        height: "240",
                        type: "radialBar"
                      }, null, 8, ["options", "series"]),
                      _withDirectives(_createElementVNode("div", {
                        class: _normalizeClass([
										+_ctx.compare_with_last.average_result >= 0
											? 'bg-green-50 text-green-400'
											: 'bg-sienna-50 text-sienna-400'
									, "grow-value flex flex-nowrap rounded-lg py-1 px-2 items-center w-fit"])
                      }, [
                        (_openBlock(), _createElementBlock("svg", {
                          class: _normalizeClass({
											'transform rotate-180':
												+_ctx.compare_with_last.average_result >=
												0,
										}),
                          fill: "none",
                          height: "12",
                          viewBox: "0 0 10 12",
                          width: "10",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, _hoisted_128, 2)),
                        _createElementVNode("div", _hoisted_129, _toDisplayString(Math.abs(
												Math.round(
													_ctx.compare_with_last.average_result *
														10
												) / 10
											)) + "% ", 1)
                      ], 2), [
                        [_vShow, 
										+_ctx.compare_with_last.average_result !== 0
									]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_130, [
                      _createVNode(_component_apexchart, {
                        options: _ctx.chartOptions2_2,
                        series: [
										Math.round(
											((+_ctx.weeklyReport?.average_cooperation_scale *
												100) /
												5) *
												10
										) / 10,
									],
                        height: "240",
                        type: "radialBar"
                      }, null, 8, ["options", "series"]),
                      _withDirectives(_createElementVNode("div", {
                        class: _normalizeClass([
										+_ctx.compare_with_last?.average_cooperation_scale >=
										0
											? 'bg-green-50 text-green-400'
											: 'bg-sienna-50 text-sienna-400'
									, "grow-value flex flex-nowrap rounded-lg py-1 px-2 items-center w-fit"])
                      }, [
                        (_openBlock(), _createElementBlock("svg", {
                          class: _normalizeClass({
											'transform rotate-180':
												+_ctx.compare_with_last?.average_cooperation_scale >=
												0,
										}),
                          fill: "none",
                          height: "12",
                          viewBox: "0 0 10 12",
                          width: "10",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, _hoisted_132, 2)),
                        _createElementVNode("div", _hoisted_133, _toDisplayString(Math.abs(
												Math.round(
													+_ctx.compare_with_last?.average_cooperation_scale *
														10
												) / 10
											)) + "% ", 1)
                      ], 2), [
                        [_vShow, 
										+_ctx.compare_with_last?.average_cooperation_scale !==
										0
									]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_134, [
                      _createVNode(_component_apexchart, {
                        options: _ctx.chartOptions2_3,
                        series: [
										Math.round(
											((+_ctx.weeklyReport?.average_emotion_scale *
												100) /
												5) *
												10
										) / 10,
									],
                        height: "240",
                        type: "radialBar"
                      }, null, 8, ["options", "series"]),
                      _withDirectives(_createElementVNode("div", {
                        class: _normalizeClass([
										+_ctx.compare_with_last?.average_emotion_scale >=
										0
											? 'bg-green-50 text-green-400'
											: 'bg-sienna-50 text-sienna-400'
									, "grow-value flex flex-nowrap rounded-lg py-1 px-2 items-center w-fit"])
                      }, [
                        (_openBlock(), _createElementBlock("svg", {
                          class: _normalizeClass({
											'transform rotate-180':
												+_ctx.compare_with_last?.average_emotion_scale >=
												0,
										}),
                          fill: "none",
                          height: "12",
                          viewBox: "0 0 10 12",
                          width: "10",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, _hoisted_136, 2)),
                        _createElementVNode("div", _hoisted_137, _toDisplayString(Math.abs(
												Math.round(
													+_ctx.compare_with_last?.average_emotion_scale *
														10
												) / 10
											)) + "% ", 1)
                      ], 2), [
                        [_vShow, 
										+_ctx.compare_with_last?.average_emotion_scale !==
										0
									]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_138, [
                  _hoisted_139,
                  _createElementVNode("div", _hoisted_140, [
                    _createElementVNode("div", _hoisted_141, _toDisplayString(_ctx.weeklyReport?.lesson_count), 1),
                    _hoisted_142,
                    (!_ctx.enableSessionCount)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_143, " (PH không xem được thông tin này) "))
                      : _createCommentVNode("", true),
                    (
									_ctx.attendance.attendance_percent >= 0 && false
								)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_144, " Tỷ lệ chuyên cần của trẻ tuần này so với tuần trước "))
                      : _createCommentVNode("", true),
                    false
                      ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                          (_ctx.attendance.attendance_percent > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_146, _toDisplayString(Math.abs(
											Math.round(
												+_ctx.attendance.attendance_percent *
													10
											) / 10
										) + '%'), 1))
                            : _createCommentVNode("", true),
                          _withDirectives(_createElementVNode("div", {
                            class: _normalizeClass([
										+_ctx.attendance?.attendance_compare_with_last_percent >=
										0
											? 'bg-green-50 text-green-400'
											: 'bg-sienna-50 text-sienna-400'
									, "grow-value flex flex-nowrap rounded-lg py-1 px-2 items-center w-fit"])
                          }, [
                            (_openBlock(), _createElementBlock("svg", {
                              class: _normalizeClass({
											'transform rotate-180':
												+_ctx.attendance?.attendance_compare_with_last_percent >=
												0,
										}),
                              fill: "none",
                              height: "12",
                              viewBox: "0 0 10 12",
                              width: "10",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, _hoisted_148, 2)),
                            _createElementVNode("div", _hoisted_149, _toDisplayString(Math.abs(
												Math.round(
													+_ctx.attendance?.attendance_compare_with_last_percent *
														10
												) / 10
											)) + "% ", 1)
                          ], 2), [
                            [_vShow, 
										+_ctx.attendance?.attendance_compare_with_last_percent !==
										0
									]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            (_ctx.radarData.length && _ctx.radarData[0]?.data.length >= 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                  _createElementVNode("div", _hoisted_151, [
                    _hoisted_152,
                    _createElementVNode("div", _hoisted_153, [
                      _createVNode(_component_apexchart, {
                        options: _ctx.radarChartOptions,
                        series: _ctx.radarData,
                        height: "700",
                        type: "radar"
                      }, null, 8, ["options", "series"]),
                      _createElementVNode("div", _hoisted_154, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (c, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: c,
                            class: "flex items-center flex-nowrap gap-2"
                          }, [
                            _createElementVNode("div", _hoisted_155, _toDisplayString(index + 1) + ": " + _toDisplayString(c), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_156, [
              _createElementVNode("div", _hoisted_157, [
                _hoisted_158,
                _createElementVNode("div", _hoisted_159, [
                  _createVNode(_component_apexchart, {
                    ref: "mixChart",
                    options: _ctx.mixChartOptions,
                    series: _ctx.emotion_cooperation_result_by_day_data,
                    height: "600",
                    width: "100%"
                  }, null, 8, ["options", "series"])
                ])
              ])
            ]),
            _hoisted_160,
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assessments_by_skill_group, (ass, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "mt-10"
                }, [
                  _createElementVNode("div", _hoisted_161, _toDisplayString(index + 1) + ". " + _toDisplayString(ass?.skill), 1),
                  _createElementVNode("div", _hoisted_162, [
                    _createElementVNode("div", _hoisted_163, [
                      _createElementVNode("div", _hoisted_164, [
                        _createElementVNode("table", _hoisted_165, [
                          _hoisted_166,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ass?.data, (assessment, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: assessment.goal,
                                class: _normalizeClass([
												index % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50'
											, "text-neutral-700 hover:bg-orange-50 cursor-pointer"]),
                                onClick: ($event: any) => (
												_ctx.$router.push(
													`/goal/${_ctx.student_id}/${assessment.goal_id}`
												)
											)
                              }, [
                                _createElementVNode("td", _hoisted_168, [
                                  _createElementVNode("div", _hoisted_169, _toDisplayString(index + 1), 1)
                                ]),
                                _createElementVNode("td", _hoisted_170, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_171, _toDisplayString(assessment?.goal), 1),
                                    _createElementVNode("div", _hoisted_172, [
                                      (
																assessment?.raw_source
															)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_173, _toDisplayString(assessment?.display_source), 1))
                                        : _createCommentVNode("", true),
                                      (
																assessment?.state
															)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_174, _toDisplayString(_ctx.$filters.sourceMap(
																	assessment?.state,
																	assessment.editable
																)), 1))
                                        : _createCommentVNode("", true),
                                      (
																assessment?.assistance_levels
															)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(assessment?.assistance_levels, (ass) => {
                                            return (_openBlock(), _createElementBlock("div", { key: ass }, [
                                              _createElementVNode("div", _hoisted_175, _toDisplayString(ass), 1)
                                            ]))
                                          }), 128))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_176, [
                                      (
																assessment?.has_goal_media
															)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_177, _hoisted_179))
                                        : _createCommentVNode("", true),
                                      (
																assessment.number_of_assessment >
																0
															)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_180, " ĐÃ HỌC " + _toDisplayString(assessment.number_of_assessment) + " NGÀY ", 1))
                                        : _createCommentVNode("", true),
                                      (
																assessment?.completed_at
															)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_181, _hoisted_183))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (
															assessment?.parent
																?.sub_goal_count >
															0
														)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                                          _hoisted_185,
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_186, _toDisplayString(assessment
																		?.parent
																		?.goal_name), 1),
                                            _createElementVNode("div", _hoisted_187, _toDisplayString(assessment
																		?.parent
																		?.sub_goal_count) + " MỤC TIÊU ", 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_188, [
                                  _createElementVNode("div", null, [
                                    (
															assessment.has_goal_media
														)
                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_189, _hoisted_192))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_193, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", {
                                      style: _normalizeStyle({
															background:
																_ctx.$filters.tagResult(
																	assessment?.result
																)?.background,
															color: _ctx.$filters.tagResult(
																assessment?.result
															)?.color,
														}),
                                      class: "mt-1 py-0.5 px-2.5 rounded-full text-neutral-700 h-fit w-fit font-semibold text-sm shadow-input"
                                    }, _toDisplayString(assessment?.result), 5)
                                  ])
                                ])
                              ], 10, _hoisted_167))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ass?.data, (assessment, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: assessment.goal,
                        class: "shadow-sm rounded-lg overflow-hidden md:hidden mb-4 bg-white",
                        onClick: ($event: any) => (
								_ctx.$router.push(
									`/goal/${_ctx.student_id}/${assessment.goal_id}`
								)
							)
                      }, [
                        _createElementVNode("div", _hoisted_195, [
                          _createElementVNode("div", null, _toDisplayString(index + 1) + ". " + _toDisplayString(assessment?.goal), 1),
                          (assessment?.goal?.assistance_levels)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_196, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assessment?.goal
											?.assistance_levels, (ass) => {
                                  return (_openBlock(), _createElementBlock("div", { key: ass }, [
                                    _createElementVNode("div", _hoisted_197, _toDisplayString(ass), 1)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_198, [
                          _hoisted_199,
                          _createElementVNode("div", {
                            style: _normalizeStyle({
										background: _ctx.$filters.tagResult(
											assessment?.result
										)?.background,
										color: _ctx.$filters.tagResult(
											assessment?.result
										)?.color,
									}),
                            class: "mt-2 py-0.5 px-2.5 rounded-full text-neutral-700 h-fit w-fit font-semibold text-xs shadow-input"
                          }, _toDisplayString(assessment?.result), 5)
                        ])
                      ], 8, _hoisted_194))
                    }), 128))
                  ])
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_200, [
            _createVNode(_component_Loading)
          ]))
    ])
  ], 64))
}